/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import exportModal from 'shared/ui/mixins/common/export-modal.js';

// Components
import Checkboxes from 'shared/ui/components/form-components/Checkboxes.vue';

const __vue_script__ = {
    name: 'FpTypeExportModal',

    components: {
        Checkboxes
    },

    mixins: [exportModal],

    props: {
        event: {
            type: Object,
            required: true
        },

        immediateDownload: {
            type: Boolean,
            default: false
        },

        fpType: {
            type: String,
            required: true
        },

        exportType: {
            type: String,
            default: 'generic-fp-type',
        },

        title: {
            type: String,
            required: true
        },

        icon: {
            type: String,
            default: 'list'
        },

        iconStyle: {
            type: String,
            default: ''
        },

        mandatoryFields: {
            type: Array,
            default: () => []
        },

        showFields: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            fields: [],
            ready: false,
            exportFields: [],
            showMoreFields: false,
            submitting: false
        };
    },

    async created() {
        try {
            const fields = await this.$services.metadata.getMetadataForType(this.event._id, this.fpType, false, true);
            this.fields = this.$utils.collections
                .sortByOrder(fields, '__key', true)
                .map(field => {
                    return {
                        name: field.__key,
                        label: field.label || field.__key,
                        value: this.mandatoryFields.includes(field.__key),
                        disabled: this.mandatoryFields.includes(field.__key),
                        hidden: this.mandatoryFields.includes(field.__key)
                    };
                });
        } catch (error) {
            console.error('[FpTypeExportModal] Could not load fields list', error.message);
        } finally {
            this.ready = true;
        }
        if (this.immediateDownload) {
            this.submit();
        }
    },

    methods: {
        async submit() {
            try {
                if (this.submitting) {
                    return;
                }

                this.submitting = true;
                if (this.fields.length && this.showFields) {
                    const valid = await this.$refs.form.validate();
                    if (!valid) {
                        return;
                    }
                }

                const data = {
                    fields: this.exportFields,
                    options: {
                        fpType: this.fpType
                    }
                };

                console.info('[FpTypeExportModal] Sending an export request:', data);

                const task = await this.$services.documents.exportDocs(this.event._id, this.exportType, data);
                this.onFormCompleted(task);

            } catch (error) {
                console.error('[FpTypeExportModal] An error occurred', error.message);
                this.handleError(error);

            } finally {
                this.submitting = false;
            }
        },

        /**
         * Tracks the export job for the current report
         *
         * @param {object} task the remote task to track for the progress
         */
        async onFormCompleted(task) {
            try {
                const jobId = task.exportId;
                const jobUrl = this.$services.analytics.getReportProgressUrl(this.event._id, jobId);

                await this.trackJob(jobId, jobUrl, jobUrl);

                this.downloadPath = this.$services.analytics.getReportResultUrl(this.event._id, jobId, this.liveStreamId);

            } catch (error) {
                this.handleError(error);

            } finally {
                this.polling = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fp-type-export-modal modal-wrapper",
      class: { polling: _vm.polling },
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("span", {
          staticClass: "close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
        _c("h3", [
          _c("div", { staticClass: "icon-wrapper", class: _vm.iconStyle }, [
            _c("i", { class: "ic-" + _vm.icon }),
          ]),
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _vm.showDownloadButton
            ? [
                _c("div", { staticClass: "download-link-wrapper" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("general.could_not_download"))),
                  ]),
                  _c(
                    "a",
                    {
                      ref: "downloadLink",
                      staticClass: "btn btn-primary",
                      attrs: { href: _vm.downloadPath, target: "_blank" },
                    },
                    [_vm._v(_vm._s(_vm.$t("analytics.exports.download")))]
                  ),
                ]),
              ]
            : [
                !_vm.error
                  ? [
                      _vm.ready && !_vm.polling
                        ? _c("validation-observer", {
                            ref: "form",
                            attrs: { slim: true },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var handleSubmit = ref.handleSubmit
                                    return [
                                      _c(
                                        "form",
                                        {
                                          staticClass: "fp-type-form",
                                          on: {
                                            submit: function ($event) {
                                              $event.preventDefault()
                                              return handleSubmit(_vm.submit)
                                            },
                                          },
                                        },
                                        [
                                          _vm.fields.length && _vm.showFields
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "fields-list",
                                                  class: {
                                                    full: _vm.showMoreFields,
                                                  },
                                                },
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      slim: true,
                                                      name: "fields",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c("checkboxes", {
                                                                attrs: {
                                                                  label: _vm.$t(
                                                                    "users.exports.fields"
                                                                  ),
                                                                  errors:
                                                                    errors,
                                                                  options:
                                                                    _vm.fields,
                                                                  name: "fields",
                                                                  tip: _vm.$t(
                                                                    "users.exports.fields_hint"
                                                                  ),
                                                                  inline: true,
                                                                  itemised: true,
                                                                  "show-toggler": true,
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.exportFields,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.exportFields =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "exportFields",
                                                                },
                                                              }),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "has-action full-list-toggler",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.showMoreFields =
                                                            !_vm.showMoreFields
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.showMoreFields
                                                            ? _vm.$t(
                                                                "general.show_less"
                                                              )
                                                            : _vm.$t(
                                                                "general.show_more"
                                                              )
                                                        )
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "ic-chevron-down",
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3559706524
                            ),
                          })
                        : _vm._e(),
                      _vm.polling
                        ? _c("progress-bar", {
                            attrs: { progress: _vm.progress },
                          })
                        : _vm._e(),
                    ]
                  : [
                      _c("div", { staticClass: "alert alert-error" }, [
                        _vm.error
                          ? _c("p", [_vm._v(_vm._s(_vm.error))])
                          : _vm._e(),
                        _c("p", [_vm._v(_vm._s(_vm.$t("general.try_later")))]),
                      ]),
                    ],
              ],
        ],
        2
      ),
      !_vm.showDownloadButton
        ? _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("general.cancel")))]
            ),
            !_vm.immediateDownload
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", disabled: _vm.disableSubmit },
                    on: { click: _vm.submit },
                  },
                  [_vm._v(_vm._s(_vm.$t("analytics.exports.download")))]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/modals/FpTypeExportModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__